export default "__VITE_ASSET__6614df00__"